import { render, staticRenderFns } from "./LastGameWidget.vue?vue&type=template&id=74605971&scoped=true"
import script from "./LastGameWidget.vue?vue&type=script&lang=js"
export * from "./LastGameWidget.vue?vue&type=script&lang=js"
import "./LastGameWidget.vue?vue&type=style&index=0&id=74605971&prod&scoped=true&lang=css"
/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74605971",
  null
  
)

export default component.exports